import {
  MdAccountTree,
  MdEmail,
  MdOutlineAddCircle,
  MdSettings,
} from "react-icons/md";
import {
  ACCOUNTS_ROUTE,
  ADD_FUNDS_ROUTE,
  INTRODUCING_BROKER_ROUTE,
  LEGAL_DOCUMENTS_URL,
  NEWS_ROUTE,
  PROFILE_ROUTE,
  SETTINGS_ROUTE,
  TRADE_ROUTE,
  TRANSACTION_ROUTE,
  WITHDRAW_ROUTE,
} from "_constants";
import { PiFilesBold, PiHandWithdrawFill } from "react-icons/pi";
import { AiOutlineFileSearch } from "react-icons/ai";
import { BiSolidPhoneCall } from "react-icons/bi";
import { TbGraphFilled } from "react-icons/tb";
import { FaCircleUser } from "react-icons/fa6";
import { ImUserTie } from "react-icons/im";
import { GiNewspaper } from "react-icons/gi";

export const homeQuickLinkItems = [
  {
    title: "Deposit",
    icon: MdOutlineAddCircle,
    path: ADD_FUNDS_ROUTE,
  },
  {
    title: "Withdraw",
    icon: PiHandWithdrawFill,
    path: WITHDRAW_ROUTE,
  },
  {
    title: "Trade",
    icon: TbGraphFilled,
    path: TRADE_ROUTE,
  },
  {
    title: "Transactions",
    icon: AiOutlineFileSearch,
    path: TRANSACTION_ROUTE,
  },
  {
    title: "Profile",
    icon: FaCircleUser,
    path: PROFILE_ROUTE,
  },
  {
    title: "Introducing Broker",
    icon: ImUserTie,
    path: INTRODUCING_BROKER_ROUTE,
  },
  {
    title: "Settings",
    icon: MdSettings,
    path: SETTINGS_ROUTE,
  },
  {
    title: "Accounts",
    icon: MdAccountTree,
    path: ACCOUNTS_ROUTE,
  },
  {
    title: "News",
    icon: GiNewspaper,
    path: NEWS_ROUTE,
  },
  {
    title: "Legal",
    icon: PiFilesBold,
    path: LEGAL_DOCUMENTS_URL,
  },
];

export const homeSupportItems = [
  {
    value: "support@empirefx.com",
    prefix: "mailto",
    icon: MdEmail,
  },
  {
    value: "+254793333333",
    prefix: "tel",
    icon: BiSolidPhoneCall,
  },
];
